import type { KeyboardEvent } from "react";

// Input types that natively activate (click) on Enter rather than implicitly
// submitting the form - Enter on these must be left alone.
const ACTIVATION_INPUT_TYPES = new Set([
  "submit",
  "button",
  "reset",
  "checkbox",
  "file",
  "color",
  "range",
]);

export function preventEnterSubmit(event: KeyboardEvent<HTMLFormElement>) {
  const target = event.target as HTMLInputElement;
  if (
    event.key === "Enter" &&
    target.tagName === "INPUT" &&
    !ACTIVATION_INPUT_TYPES.has(target.type)
  ) {
    event.preventDefault();
  }
}

const FOCUSABLE_CONTROL_SELECTOR =
  'input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled), button:not(:disabled)';

export function focusFirstInvalidField(containerSelector: string) {
  requestAnimationFrame(() => {
    const container = document.querySelector(containerSelector);
    const invalidEls =
      container?.querySelectorAll<HTMLElement>('[aria-invalid="true"]') ?? [];

    const invalidElsArray = Array.from(invalidEls);

    for (const invalidEl of invalidElsArray) {
      const focusTarget = invalidEl.matches(FOCUSABLE_CONTROL_SELECTOR)
        ? invalidEl
        : invalidEl.querySelector<HTMLElement>(FOCUSABLE_CONTROL_SELECTOR);

      if (focusTarget) {
        focusTarget.focus();
        focusTarget.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
    }

    invalidElsArray[0]?.scrollIntoView({ behavior: "smooth", block: "center" });
  });
}
